import React, { useState } from 'react';
import Signature from './Signature';

function Form() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [title, setTitle] = useState('');
  const [phone, setPhone] = useState('');

  const handleSubmit = (event) => {
    event.preventDefault();
  };

  return (
    <div className="container" style={{ marginTop: '100px', marginBottom: '100px' }}>
      <div style={{ marginBottom: '60px' }}>
        <h1>Goddess Retreats Email Signature Creator</h1>
        <p>Fill in your details and submit the form to generate your custom email signature.</p>
      </div>
      <form onSubmit={handleSubmit} className="flex flex-col gap-10 flex-row">
        <div className="input-container">
          <label>Your name</label>
          <input type="text" value={name} onChange={(e) => setName(e.target.value)} placeholder="Name" className={`d-block w-full`} />
        </div>
        <div className="input-container">
          <label>Your title</label>
          <input type="text" value={title} onChange={(e) => setTitle(e.target.value)} placeholder="Title" />
        </div>
        <div className="input-container">
          <label>Your phone</label>
          <input type="text" value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="Phone" />
        </div>
        <div className="input-container">
          <label>Your email</label>
          <input type="text" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" />
        </div>
        {/* <button type="submit">Submit</button> */}
      </form>
      <div className={'signature-container'}>
        <Signature name={name} title={title} phone={phone} email={email} />
      </div>
    </div>
  );
}
export default Form;
